import {
  getFontColor
} from "./chunk-QNPCRFUV.js";
import {
  getTypographyString
} from "./chunk-EWNQ3Z3L.js";

// src/styles/typography.tsx
var applyTypography = (theme, typographyType, size, color = "inherit", applyToAll = true) => {
  const selector = applyToAll ? "&, & *" : "&";
  return `
    ${selector} {
      ${getTypographyString(theme, typographyType, size)};
      color: ${getFontColor(theme, color)};
    }
  `;
};

export {
  applyTypography
};
